// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "../application"
import GaController from "./ga_controller.js"
import PixelController from "./pixel_controller.js"
import KlaviyoController from "./klaviyo_controller.js"
import ErrorFocusController from "./error_focus_controller.js"
import NotificationController from "./notification_controller.js"
import ReadyController from "../common/ready_controller.js"
import ReadMoreController from "../common/read_more_controller.js"
import CookiePolicyController from "./cookie_policy_controller.js"
import SignupFormController from "./signup_form_controller.js"
import CustomerFormController from "./customer_form_controller.js"
import SelectButtonsController from "./select_buttons_controller.js"
import CheckboxButtonsController from "./checkbox_buttons_controller.js"
import PaymentFormController from "./payment_form_controller.js"
import PaymentFormFinixController from "./payment_form_finix_controller.js"
import GiftCardsPopupController from "./gift_cards_popup_controller.js"
import StickyCtaController from "./sticky_cta_controller.js"
import TimerController from "./timer_controller.js"
import WindowLocationController from "./window_location_controller.js"
import ModalController from "./modal_controller.js"
import FrictionFormController from "./friction_form_controller.js"
import BrowserController from "./browser_controller.js"
import PollingController from "./polling_controller.js"
import PlanController from "./plan_controller.js"
import PlanPaymentFormController from "./plan_payment_form_controller.js"
import OrderSummaryController from "./order_summary_controller.js"
import QuizFocusController from "./quiz_focus_controller.js"
import GiftCardsFormController from "./gift_cards_form_controller.js"
import ExitFrictionController from "./exit_friction_controller.js"
import DatepickerController from "../common/datepicker_controller.js"
import TiktokController from "./tiktok_controller.js"
import SurveyQuizQuestionController from "./survey_quiz_question_controller.js"
import ShipmentDetailsController from "./shipment_details_controller.js"
import GoogleAutocompleteController from "./google_autocomplete_controller.js"
import TextToggleController from "./text_toggle_controller.js"
import CancelReasonController from "./cancel_reason_controller.js"
import InputCharacterCounter from "./input_character_counter_controller.js"
import DisplayToggleController from "./display_toggle_controller.js"
import SelfCheckoutValidationController from "./self_checkout_validation.js"
import FinixSessionController from "./finix_session_controller.js"

// tracking
application.register("ga", GaController)
application.register("pixel", PixelController)
application.register("klaviyo", KlaviyoController)
application.register("tiktok", TiktokController)

application.register("display-toggle", DisplayToggleController)
application.register("text-toggle", TextToggleController)

application.register("self-checkout-validation", SelfCheckoutValidationController)
application.register("google-autocomplete", GoogleAutocompleteController)
application.register("read-more", ReadMoreController)
application.register("ready", ReadyController)
application.register("error-focus", ErrorFocusController)
application.register("notification", NotificationController)
application.register("cookie-policy", CookiePolicyController)
application.register("signup-form", SignupFormController)
application.register("customer-form", CustomerFormController)
application.register("select-buttons", SelectButtonsController)
application.register("checkbox-buttons", CheckboxButtonsController)
application.register("payment-form", PaymentFormController)
application.register("payment-form-finix", PaymentFormFinixController)
application.register("gift-cards-popup", GiftCardsPopupController)
application.register("sticky-cta", StickyCtaController)
application.register("timer", TimerController)
application.register("window-location", WindowLocationController)
application.register("modal", ModalController)
application.register("friction-form", FrictionFormController)
application.register("browser", BrowserController)
application.register("polling", PollingController)
application.register("plan", PlanController)
application.register("plan-payment-form", PlanPaymentFormController)
application.register("order-summary", OrderSummaryController)
application.register("quiz-focus", QuizFocusController)
application.register("gift-cards-form", GiftCardsFormController)
application.register("exit-friction", ExitFrictionController)
application.register("datepicker", DatepickerController)
application.register("survey-quiz-question", SurveyQuizQuestionController)
application.register("shipment-details", ShipmentDetailsController)
application.register("cancel-reason", CancelReasonController)
application.register("input-character-counter", InputCharacterCounter)
application.register("finix-session", FinixSessionController)